import { useMutation } from 'react-query'
import { Carousel } from 'react-responsive-carousel'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { Modal } from 'components-ref/molecules/modal/modal'
import { createAnnouncement } from 'services/endpoints/announcement'
import colors from 'styles/colors'
import { type Announcement } from 'types/api/announcement'
import 'react-responsive-carousel/lib/styles/carousel.min.css';

interface AnnouncementsModalProps {
    onClose: () => void
    announcements: Announcement[]
}

export const AnnouncementsModal = ({
    onClose,
    announcements
}: AnnouncementsModalProps) => {
    const createAnnouncementMutation = useMutation(async (id: number) => await createAnnouncement(id), {})


    return (
        <Modal onClose={onClose} hasShadow={true} maxWidth={50}>
            <CarouselWrapper>
                <Carousel
                    axis='horizontal'
                    autoPlay={false}
                    showArrows={false}
                    showStatus={false}
                    showThumbs={false}
                    infiniteLoop={true}
                >
                    {announcements?.map((item: Announcement, index: number) => (
                        <ContentWrapper key={index}>
                            <InfoWrapper>
                                <img
                                    width={180}
                                    height={130}
                                    src={item.image_src}
                                    alt='Image'
                                />
                                <ModalTitle>{item.title}</ModalTitle>
                                <ModalDescription>
                                    {item.description}
                                </ModalDescription>
                            </InfoWrapper>
                            <ButtonWrapper>
                                {item.link ? (
                                    <Link to={item.link}>
                                        <Button
                                            text={item.button_text}
                                            color='black'
                                            font='sf-16-normal'
                                            width='20'
                                            height='5'
                                            clickFn={() => {
                                                createAnnouncementMutation.mutate(
                                                    item.id
                                                )
                                            }}
                                        />
                                    </Link>
                                ) : (
                                    <Button
                                        text={item.button_text}
                                        color='black'
                                        font='sf-16-normal'
                                        width='20'
                                        height='5'
                                        clickFn={() => {
                                            createAnnouncementMutation.mutate(
                                                item.id
                                            )
                                        }}
                                    />
                                )}
                            </ButtonWrapper>
                        </ContentWrapper>
                    ))}
                </Carousel>
            </CarouselWrapper>
        </Modal>
    )
}

const CarouselWrapper = styled.div`
    .carousel.carousel-slider { overflow: unset; }

    .carousel .control-dots {
        bottom: 6.5rem;

        .dot {
            width: 6px;
            height: 6px;
            background: rgba(129, 141, 175, 0.5);
            box-shadow: none;
        }

        .dot.selected {
            background: #2f98fe;
        }
    }
`

const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    height: 100%;
    flex-direction: column;
`

const InfoWrapper = styled.div`
    img {
        object-fit: contain;
        min-height: 13rem;
    }

    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 2rem;
    padding: 0 2rem;
`

const ModalTitle = styled.div`
    font-size: 2.4rem;
    font-weight: 600;
    text-align: center;
`

const ModalDescription = styled.div`
    font-size: 1.4rem;
    font-weight: 400;
    text-align: center;
    margin-bottom: 4rem;
    color: ${colors.stormyBlue};
    width: 250px;
    overflow: hidden;
`

const ButtonWrapper = styled.div`
    width: 100%;
    margin-top: 2rem;
    display: flex;
    justify-content: center;
`
